const ADD_BOOK_PUBLISHER = "ADD_BOOK_PUBLISHER";
const UPDATE_BOOK_PUBLISHER = "UPDATE_BOOK_PUBLISHER";
const DELETE_BOOK_PUBLISHER = "DELETE_BOOK_PUBLISHER";
const BOOK_PUBLISHERS = "BOOK_PUBLISHERS";
const ADD_BOOK_PUBLISHER_ERROR = "ADD_BOOK_PUBLISHER_ERROR";
const BOOK_PUBLISHER_DETAILS = "BOOK_PUBLISHER_DETAILS";


export {
	ADD_BOOK_PUBLISHER,
	UPDATE_BOOK_PUBLISHER,
	DELETE_BOOK_PUBLISHER,
	BOOK_PUBLISHERS,
	ADD_BOOK_PUBLISHER_ERROR,
	BOOK_PUBLISHER_DETAILS,
};
